@if (!control.disabled) {
  <div class="flex-vertical width-100pc gap-16">
    <oui-select
      label="Fonds événementiels"
      [control]="control"
      [hint]="hint"
      [options]="options"
      class="width-100pc"
    [multiple]="true"></oui-select>
  </div>
}
